import { Component } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { laporGalat } from "../lib/laporGalat";
import { formatApiErrorDetail } from "../lib/api";

// Menangkap uncaught error saat render/commit agar tidak meng-unmount seluruh
// halaman (yang tampak seperti "keluar diam-diam" ke list). Menampilkan pesan
// jelas + tombol coba lagi, dan mencatat stack + konteks ke console.
export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    const ctx = this.props.context || "komponen";
    // Jejak diagnosis: konteks, pesan, stack render, dan info tambahan (mis. field/nilai).
    // eslint-disable-next-line no-console
    console.error(`[ErrorBoundary:${ctx}]`, {
      message: error?.message,
      stack: error?.stack,
      componentStack: info?.componentStack,
      extra: this.props.extra,
    });
    // PR log galat: satu catatan ke server (disensor di server); tampilan untuk pembeli tidak berubah
    laporGalat(error);
  }

  reset = () => {
    this.setState({ error: null });
    this.props.onReset?.();
  };

  render() {
    if (this.state.error) {
      if (this.props.renderFallback) {
        return this.props.renderFallback({ error: this.state.error, reset: this.reset });
      }
      return (
        <div className="rounded-lg border border-red-500/40 bg-red-500/10 p-4 my-2" data-testid="error-boundary-fallback" role="alert">
          <div className="flex items-start gap-3">
            <AlertTriangle size={18} className="text-red-400 mt-0.5 shrink-0" />
            <div className="flex-1 min-w-0">
              {/* Halaman pembeli (prop `pembeli`, teks 28/10/2026): tanpa nama komponen & pesan teknis; admin tetap rinci, teks berisi token/header disaring */}
              <p className="font-semibold text-red-300">{this.props.pembeli ? "Terjadi kesalahan." : `Terjadi kesalahan di ${this.props.context || "bagian ini"}`}</p>
              {!this.props.pembeli && <p className="text-xs text-red-200/80 mt-0.5 break-words">{formatApiErrorDetail(String(this.state.error?.message || this.state.error))}</p>}
              <p className="text-[11px] text-red-200/60 mt-1">Data yang sudah Anda ketik tidak hilang. Klik "Coba lagi" untuk menampilkan kembali.</p>
              <button type="button" onClick={this.reset} data-testid="error-boundary-retry" className="mt-2 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-red-600 text-white text-xs font-semibold hover:bg-red-700">
                <RefreshCw size={13} /> {this.props.retryLabel || "Coba lagi"}
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
